<template>
  <div
    class="loading-overlay"
    :class="{ 'full-screen': fullScreen, loading }"
  >
    <div class="spinner-container">
      <LoadingSpinner />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
    fullScreen: { type: Boolean, default: true },
    standalone: { type: Boolean, default: false },
  },
}
</script>

<style lang="postcss">
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 11000;
  color: #666;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.8);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.5s ease, visibility 0.5s ease;

  &.full-screen {
    @apply bg-white;
    position: fixed;
    height: 100vh;
  }

  &.loading {
    opacity: 0.8;
    visibility: visible;
    pointer-events: auto;
  }

  .spinner-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
